let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("17Qwb"), load("dWaws"), load("7T551")]).then(() => parcelRequire('f1q2w'));